var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAUp1Vector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 527,
    height: 26,
    viewBox: "0 0 527 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.446 25C306.218 17.5373 238.984 21.5866 178.046 22.272C160.524 22.4693 142.597 23.7846 125.091 23.2214C122.808 23.1482 112.847 22.8737 110.978 21.4071C110.734 21.2162 118.502 20.4636 122.276 20.1417C129.613 19.5157 136.947 19.0539 144.279 18.3927C163.554 16.6556 183.166 15.8081 202.61 15.0273C252.522 13.0247 341.811 6.85302 390.591 15.5564C393.008 15.9876 385.536 15.4822 383.009 15.4422C378.855 15.3769 374.705 15.2824 370.55 15.2068C357.002 14.961 343.339 14.5239 329.789 14.5926C286.123 14.8127 242.302 13.7555 198.646 14.7024C185.51 14.9877 172.415 15.5801 159.273 15.8091C151.661 15.9416 152.002 16.0538 144.135 15.8991C140.724 15.8318 131.265 16.4267 133.963 15.2147C138.714 13.0795 153.565 13.6136 159.309 13.1779C185.535 11.1911 211.696 8.59655 238.056 7.2026C305.645 3.62849 374.452 3.62008 442.195 5.11539C469.907 5.72706 497.906 3.361 525.5 5.27266C458.546 0.261088 388.952 0.972639 321.631 1.11752C245.833 1.2807 170.121 1.29158 94.3219 2.21725C63.2036 2.59701 32.713 6.03158 1.5 5.78088",
    stroke: "url(#paint0_linear_1660_1569)",
    strokeWidth: 1.05,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_1569",
    x1: 1.49832,
    y1: 12.9972,
    x2: 525.5,
    y2: 12.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F69321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EB2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ED4080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1D76BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC543"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAUp1Vector);
export default __webpack_public_path__ + "static/media/aUP1Vector.67cf52e48814bfc9a3d6fc4525b7f75b.svg";
export { ForwardRef as ReactComponent };